import { Component, computed, ElementRef, HostListener, inject, OnInit } from '@angular/core';
import { ProfileService } from '../../core/services/profile.service';
import { NgIf } from '@angular/common';
import { InitialsPipe } from "../../core/pipes/initials.pipe";
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [NgIf, InitialsPipe],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {

  private elRef: ElementRef;
  private profileSv: ProfileService = inject(ProfileService);
  private readonly authService: AuthService = inject(AuthService);

  ngOnInit(): void {
    console.log(this.authService.IdToken)
  }

  // @HostListener('document: click', ['$event'])
  // onOutsideClick(event: MouseEvent): void {
  //   if(!(this.elRef.nativeElement as HTMLElement).contains(event.target as Node)) {
  //   }
  // }

  get userProfile() {
    return this.profileSv.getProfile.profile;
  }

  get fullName(): string {
    return `${this.userProfile.givenName} ${this.userProfile.sn}`;
  }

  logout() {
    this.authService.logout(this.authService.IdToken);
  }

}
